export default "__VITE_ASSET__DQy$GBU0__"